import { useMemo } from 'react';
import dayjs from 'dayjs';

import { AVAILABLE_PERIOD_COUNT, DATE_PERIOD_FORMAT, REVERSE_DATE_FORMAT } from 'constants-module';
import { capitalize } from 'helpers';
import { getLanguage } from 'store';
import { useAppSelector } from 'hooks';

import { useFetchPeriodsQuery } from '../../../../../services';

export const useAvailablePeriods = (isEditMode: boolean) => {
  const { data: periods } = useFetchPeriodsQuery();
  const language = useAppSelector(getLanguage);

  const previousMonth = dayjs().locale(language).add(-1, 'month');
  const currentMonth = dayjs().locale(language).startOf('month');

  return useMemo(() => {
    const previousPeriod = periods?.find(({ year, month }) => previousMonth.isSame(`${year}-${month}`, 'month'));
    const isActivePrevious = previousPeriod?.isActive ?? true;
    const optionsForNewCompensation = (isActivePrevious ? [-1] : []).concat([...Array(AVAILABLE_PERIOD_COUNT).keys()]); // The difference in months from the current month

    const options = isEditMode ? [-1, ...Array(AVAILABLE_PERIOD_COUNT).keys()] : optionsForNewCompensation;

    return options.map((monthIndex) => {
      const period = currentMonth.clone().add(monthIndex, 'month');

      return {
        label: capitalize(period.format(DATE_PERIOD_FORMAT)),
        value: period.format(REVERSE_DATE_FORMAT),
      };
    });
  }, [currentMonth, isEditMode, periods, previousMonth]);
};
